import React from 'react';

import Actions from './Actions';
import TrainingStatus from './TrainingStatus';

const columns = (inviteAffiliate) => [
  {
    name: 'First Name',
    selector: (row) => row.attributes.first_name,
    sortable: true,
  },
  {
    name: 'Last Name',
    selector: (row) => row.attributes.last_name,
    sortable: true,
  },
  {
    name: 'Email',
    selector: (row) => row.attributes.email,
    sortable: true,
  },
  {
    name: 'Company',
    selector: (row) => row.attributes.company_name,
    sortable: true,
  },
  {
    name: 'Training Status',
    cell: (row) => <TrainingStatus row={row} />,
  },
  {
    name: 'Actions',
    sortable: false,
    right: true,
    width: '200px',
    cell: (row) => <Actions row={row} inviteAffiliate={inviteAffiliate} />,
  },
];

export default columns;
